import classes from "./checkbox.module.css";

const CheckBox = ({ onChange, label, id, value, checked, className = "" }) => {
  return (
    <div className={`${classes.container} flex ${className}`}>
      <label className={classes.label} htmlFor={id}>
        <input
          id={id}
          type="checkbox"
          defaultChecked={checked || false}
          onChange={onChange}
          value={value}
        />
        <span className={classes.span}></span>
      </label>
      <label htmlFor={id}>{label}</label>
    </div>
  );
};

export default CheckBox;

export const CustomCheckbox = ({ checked, onChange }) => {
  return (
    <label className="relative flex min-h-[30px] min-w-[30px] cursor-pointer items-center justify-center self-start">
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="sr-only"
      />

      {/* Box SVG */}
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute inset-0"
      >
        <path
          d="M28.5833 14.9167V25.1667C28.5833 26.0728 28.2234 26.9419 27.5826 27.5826C26.9419 28.2234 26.0728 28.5833 25.1667 28.5833H4.66667C3.76051 28.5833 2.89147 28.2234 2.25072 27.5826C1.60997 26.9419 1.25 26.0728 1.25 25.1667V4.66667C1.25 3.76051 1.60997 2.89147 2.25072 2.25072C2.89147 1.60997 3.76051 1.25 4.66667 1.25H20.0417"
          stroke="black"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      {/* Checkmark SVG */}
      {checked && (
        <svg
          width="22"
          height="17"
          viewBox="0 0 22 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="relative right-[-2px]"
        >
          <path
            d="M1.25 9.79167L6.375 14.9167L20.0417 1.25"
            stroke="black"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </label>
  );
}
